module.exports = __webpack_public_path__ + "img/image_25.daa04940.png";